@let activite = this.activite();

<div class="gap-md flex h-full">
  <div class="h-full w-2/3">
    <div class="border-grey-3 mb-sm h-2/3 rounded-lg border bg-white">
      <div class="border-b-grey-3 p-sm flex justify-between border-b">
        <p class="paragraph-large-semibold">Description de l'activité</p>
      </div>
      <div class="px-md pt-sm pb-lg" [innerHtml]="activite?.description"></div>
    </div>

    <div class="border-grey-3 h-1/3 rounded-lg border bg-white">
      <div class="border-b-grey-3 p-sm flex justify-between border-b">
        <p class="paragraph-large-semibold">Déroulé et ressources pédagogiques</p>
      </div>
      <div class="gap-md px-md pt-sm pb-md flex justify-between">
        <div class="w-1/2">
          <p class="paragraph-medium-semibold pb-xs">Déroulé</p>
          <p class="paragraph-medium-medium text-grey-7">
            <a class="text-primary-lightest underline">Scier sans se couper</a> (PDF, 420Mo)
          </p>
        </div>
        <div class="gap-xs grid w-1/2">
          <p class="paragraph-medium-semibold">Ressources pédagogiques</p>
          <p class="paragraph-medium-medium text-grey-7">
            <a class="text-primary-lightest underline">Les dangers des scies</a> (PDF, 420Mo)
          </p>
          <p class="paragraph-medium-medium text-grey-7">
            <a class="text-primary-lightest underline">Le bois</a> (YouTube, 3:30)
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="border-grey-3 h-max w-1/3 rounded-lg border bg-white">
    <div class="border-b-grey-3 p-sm flex justify-between border-b">
      <p class="paragraph-large-semibold">Informations pratiques</p>
    </div>
    <div class="px-md pt-md pb-lg gap-xs text-grey-8 grid">
      <p><span class="paragraph-medium-semibold">Durée : </span>{{ activite?.duree }}</p>
      <p><span class="paragraph-medium-semibold">Modalité : </span>{{ activite?.modalite?.nom }}</p>
      <p>
        <span class="paragraph-medium-semibold">Date de création : </span
        >{{ activite?.dateCreation | date: 'dd MMM yyyy' }}
      </p>
      @if (activite?.etat !== etatActivite.TERMINEE) {
        <a [routerLink]="['../..', 'édition', activite?.id]" hlmBtn variant="secondary">
          <ng-icon name="lucidePen"></ng-icon>
          Modifier cette activité
        </a>
      }
      <button (click)="dupliquer()" hlmBtn variant="secondary">
        <ng-icon name="lucideCopy"></ng-icon>
        Dupliquer cette activité
      </button>
      @if (!estAssocie()) {
        <button (click)="toggleSequence()" hlmBtn variant="secondary">
          <ng-icon name="lucideLink2"></ng-icon>
          Lier l'activité à la séquence
        </button>
      } @else {
        <button (click)="toggleSequence()" hlmBtn variant="secondary">
          <ng-icon name="lucideLink2Off"></ng-icon>
          Délier l'activité à la séquence
        </button>
      }
    </div>
  </div>
</div>
